import React from 'react';
import Icon from '../../../components/AppIcon';

const InsightsPanel = ({ insights }) => {
  const getInsightIcon = (type) => {
    switch(type) {
      case 'success': return 'CheckCircle2';
      case 'warning': return 'AlertTriangle';
      case 'info': return 'Info';
      default: return 'Lightbulb';
    }
  };

  const getInsightColor = (type) => {
    switch(type) {
      case 'success': return 'bg-success/10 text-success border-success/20';
      case 'warning': return 'bg-warning/10 text-warning border-warning/20';
      case 'info': return 'bg-primary/10 text-primary border-primary/20';
      default: return 'bg-accent/10 text-accent border-accent/20';
    }
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-brand">
      <div className="flex items-center gap-2 mb-6">
        <Icon name="Sparkles" size={20} className="text-primary" />
        <h3 className="text-lg font-semibold text-foreground">Automated Insights</h3>
      </div>
      <div className="space-y-4">
        {insights?.map((insight, index) => (
          <div 
            key={index} 
            className={`p-4 rounded-lg border ${getInsightColor(insight?.type)} transition-brand`}
          >
            <div className="flex items-start gap-3">
              <Icon name={getInsightIcon(insight?.type)} size={20} />
              <div className="flex-1">
                <h4 className="font-semibold mb-1">{insight?.title}</h4>
                <p className="text-sm opacity-90">{insight?.description}</p>
                {insight?.recommendation && (
                  <p className="text-sm font-medium mt-2">
                    Recommendation: {insight?.recommendation}
                  </p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InsightsPanel;